export function translateToCustomFilters(
  filters: string[]
): Record<string, string[]> {
  const ret: Record<string, string[]> = {};
  for (const filter of filters) {
    if (!filter.startsWith('and(eq(feedback_key,')) {
      continue;
    }

    const key =
      'feedback_key:' + filter.split('feedback_key, "')[1].split('"), ')[0];
    const feedbackOperator = filter
      .split('(feedback_score,')[0]
      .split('"), ')[1];
    const feedbackScore = filter.split('feedback_score, ')[1].split('))')[0];
    let operator = '';
    if (feedbackOperator === 'gte') {
      operator = '>=';
    } else if (feedbackOperator === 'lte') {
      operator = '<=';
    } else if (feedbackOperator === 'lt') {
      operator = '<';
    } else if (feedbackOperator === 'gt') {
      operator = '>';
    } else if (feedbackOperator === 'eq') {
      operator = '=';
    }
    const newFilter = `${operator}${feedbackScore}`;
    if (key in ret) {
      ret[key].push(newFilter);
    } else {
      ret[key] = [newFilter];
    }
  }
  return ret;
}
